import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { store, persistor } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate
      loading={
        <div>
          <p>loading...</p>
        </div>
      }
      persistor={persistor}
    >
      <BrowserRouter>
        <App />
        <Toaster
          containerStyle={{
            top: 20,
            left: 20,
            bottom: 20,
            right: 20,
            zIndex: 10000,
          }}
          toastOptions={{
            success: {
              style: {
                background: "#fff",
                fontFamily: "Poppins",
                color: "#000",
              },
            },
          }}
        />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
